/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content",
  tableData,
  renderRow,
  getRowViewPath,
  onRowClick
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={tableData}
 renderRow={renderRow}
 getRowViewPath={getRowViewPath}
 onRowClick={onRowClick}
 width="100%"
 overflow="auto"
/>
</div>
{children}
</React.Fragment>)
}